<script>
export default {
  name: 'VcSkeleton',
  props: {
    dataQa: {
      type: String,
    },
  },
  render: function (createElement) {
    const classes = `${
      this.$attrs.height && this.$attrs.height.length > 0 ? 'VcSkeletonHeight' : ''
    }
    ${this.$attrs.width && this.$attrs.width.length > 0 ? 'VcSkeletonWidth' : ''}`;

    const props = {
      attrs: { ...this.$attrs, 'data-qa': this.$props.dataQa || 'VcSkeleton' },
      on: { ...this.$listeners },
      ref: this.$vnode.data.ref,
      style: this.$vnode.data.style,
      class: classes,
    };
    return createElement('v-skeleton-loader', props, this.$slots.default);
  },
};
</script>

<style lang="scss" scoped>
.VcSkeletonHeight {
  ::v-deep {
    .v-skeleton-loader__bone {
      height: inherit;
    }
  }
}

.VcSkeletonWidth {
  ::v-deep {
    .v-skeleton-loader__bone {
      width: inherit;
    }
  }
}
</style>
